<template>
	<div class="admin-page">
		<div class="page-header">
			<div class="filter-section">
				<el-select v-model="searchForm.level" placeholder="选择级别" class="level-select" @change="fetchUsers">
					<el-option label="全部" value=""></el-option>
					<el-option label="超级管理员" value="0" v-if="adminInfo.adminLevel === 0"></el-option>
					<el-option label="管理员" value="1" v-if="adminInfo.adminLevel === 0"></el-option>
					<el-option label="运营" value="2"></el-option>
				</el-select>
				<el-select v-model="searchForm.status" placeholder="选择状态" class="status-select" @change="fetchUsers">
					<el-option label="全部" value=""></el-option>
					<el-option label="启用" value="1"></el-option>
					<el-option label="禁用" value="0"></el-option>
				</el-select>
			</div>
			<div class="action-area">
				<el-button size="small" type="primary" @click="handleAddClick">
					<i class="el-icon-plus"></i> 添加用户
				</el-button>
			</div>
		</div>
		<div class="user-table-container">
			<el-table :data="users" border stripe class="user-table">
				<el-table-column prop="adminName" label="用户名" min-width="120"></el-table-column>
				<el-table-column prop="adminPhone" label="手机号" min-width="120"></el-table-column>
				<el-table-column prop="adminLevel" label="级别" min-width="100">
					<template slot-scope="scope">
						<el-tag :type="getLevelType(scope.row.adminLevel)">
							{{ getLevelLabel(scope.row.adminLevel) }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="adminStatus" label="状态" min-width="100">
					<template slot-scope="scope">
						<el-switch :value="scope.row.adminStatus === 1" @change="handleStatusChange(scope.row)"
							:active-text="''" :inactive-text="''"></el-switch>
					</template>
				</el-table-column>
				<el-table-column label="操作" min-width="150" fixed="right">
					<template slot-scope="scope">
						<el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="pagination-area">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
				:page-sizes="[10, 20, 50]" :page-size="pageCount" :total="total"
				layout="total, sizes, prev, pager, next, jumper">
			</el-pagination>
		</div>
		<el-dialog :visible.sync="addDialogVisible" :title="isEdit ? '编辑用户' : '添加用户'" width="500px">
			<el-form :model="userForm" label-width="100px">
				<el-form-item label="用户名" :required="true">
					<el-input v-model="userForm.adminName" placeholder="请输入用户名"></el-input>
				</el-form-item>
				<el-form-item label="手机号" :required="true">
					<el-input v-model="userForm.adminPhone" placeholder="请输入11位手机号" maxlength="11" @blur="validatePhone"></el-input>
				</el-form-item>
				<el-form-item label="密码" :required="!isEdit">
					<el-input v-model="userForm.adminPwd" placeholder="请输入密码"></el-input>
				</el-form-item>
				<el-form-item label="级别">
					<el-radio-group v-model="userForm.adminLevel">
						<el-radio :label="0" v-if="adminInfo.adminLevel === 0">超级管理员</el-radio>
						<el-radio :label="1" v-if="adminInfo.adminLevel === 0">管理员</el-radio>
						<el-radio :label="2">运营</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="状态">
					<el-radio-group v-model="userForm.adminStatus">
						<el-radio :label="1">启用</el-radio>
						<el-radio :label="0">禁用</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="handleCancel">取消</el-button>
				<el-button type="primary" @click="handleSubmit">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import axios from 'axios'
	const BASE_URL = 'https://ai.boningnet.cn/api'

	export default {
		name: 'Admin',
		data() {
			return {
				BASE_URL: BASE_URL,
				users: [],
				pageNum: 1,
				pageCount: 20,
				total: 0,
				searchForm: {
					level: '',
					status: ''
				},
				addDialogVisible: false,
				isEdit: false,
				userForm: {
					adminToken: '',	
					adminName: '',
					adminPhone: '',
					adminPwd: '',
					adminLevel: 1,
					adminStatus: 1
				},
				editId: null,
				adminInfo: {}
			}
		},
		mounted() {
			this.adminInfo = JSON.parse(localStorage.getItem('adminInfo'))
			this.fetchUsers()
		},
		methods: {
			fetchUsers() {
				const params = {
					token: this.adminInfo.adminToken,
					pageNum: this.pageNum,
					pageCount: this.pageCount
				}
				if (this.searchForm.level !== '') {
					params.adminLevel = parseInt(this.searchForm.level)
				}
				if (this.searchForm.status !== '') {
					params.adminStatus = parseInt(this.searchForm.status)
				}

				var url=''
				if(this.adminInfo.adminLevel === 0){
					url='/admin/list'
				}else{
					url='/admin/list?adminUpId='+this.adminInfo.adminId
				}
				axios.get(`${BASE_URL}${url}`, {
					params
				}).then(res => {
					this.users = res.data || []
					this.total = res.data && res.data.allcount ? res.data.allcount : 0
					if (Array.isArray(this.users) && this.users.length === 0) {
						this.$message.info('暂无用户数据')
					}
				}).catch(() => {
					this.$message.error('获取用户列表失败')
				})
			},
			getLevelType(level) {
				switch (level) {
					case 0:
						return 'danger'
					case 1:
						return 'primary'
					case 2:
						return 'success'
					default:
						return ''
				}
			},
			getLevelLabel(level) {
				switch (level) {
					case 0:
						return '超级管理员'
					case 1:
						return '管理员'
					case 2:
						return '运营'
					default:
						return '未知'
				}
			},
			handleStatusChange(row) {
				const newStatus = row.adminStatus === 1 ? 0 : 1
				axios.post(`${BASE_URL}/admin/update?token=${this.adminInfo.adminToken}`, {
					...row,
					adminStatus: newStatus
				}).then(() => {
					row.adminStatus = newStatus
					this.$message.success('状态更新成功')
				}).catch(() => {
					row.adminStatus = row.adminStatus === 1 ? 0 : 1
					this.$message.error('状态更新失败')
				})
			},
			handleEdit(row) {
				this.isEdit = true
				this.editId = row.adminId
				this.userForm = {
					adminName: row.adminName,
					adminToken: row.adminToken,
					adminPhone: row.adminPhone,
					adminPwd: row.adminPwd,
					adminLevel: row.adminLevel,
					adminStatus: row.adminStatus
				}
				this.addDialogVisible = true
			},
			handleCancel() {
				this.addDialogVisible = false
				this.isEdit = false
				this.editId = null
				this.userForm = {
					adminName: '',
					adminPhone: '',
					adminPwd: '',
					adminLevel: 1,
					adminStatus: 1
				}
			},
			handleAddClick() {
				this.isEdit = false
				this.editId = null
				this.userForm = {
					adminName: '',
					adminPhone: '',
					adminPwd: '',
					adminLevel: 1,
					adminStatus: 1
				}
				this.addDialogVisible = true
			},
			handleDelete(row) {
				this.$confirm('确定要删除该用户吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					axios.get(`${BASE_URL}/admin/delete?token=${this.adminInfo.adminToken}&adminId=${row.adminId}`).then(() => {
						this.$message.success('删除成功')
						this.fetchUsers()
					}).catch(() => {
						this.$message.error('删除失败')
					})
				})
			},
			validatePhone() {
				const phone = this.userForm.adminPhone
				if (!phone) {
					return true
				}
				const phoneRegex = /^1[3-9]\d{9}$/
				if (!phoneRegex.test(phone)) {
					this.$message.warning('请输入正确的11位手机号')
					return false
				}
				return true
			},
			handleSubmit() {
				if (!this.userForm.adminName) {
					this.$message.warning('请输入用户名')
					return
				}
				if (!this.userForm.adminPhone) {
					this.$message.warning('请输入手机号')
					return
				}
				if (!this.validatePhone()) {
					return
				}
				if (!this.isEdit && !this.userForm.adminPwd) {
					this.$message.warning('请输入密码')
					return
				}
				const data = {
					adminName: this.userForm.adminName,
					adminPhone: this.userForm.adminPhone,
					adminLevel: this.userForm.adminLevel,
					adminStatus: this.userForm.adminStatus,
					adminUpId: this.adminInfo.adminId
				}
				if (this.userForm.adminPwd) {
					data.adminPwd = this.userForm.adminPwd
				}
				let url = `${BASE_URL}/admin/add?token=${this.adminInfo.adminToken}`
				if (this.isEdit) {
					url = `${BASE_URL}/admin/update?token=${this.adminInfo.adminToken}`
					data.adminId = this.editId
				}
				axios.post(url, data).then(() => {
					this.$message.success(this.isEdit ? '编辑成功' : '添加成功')
					this.fetchUsers()
					this.handleCancel()
				}).catch(() => {
					this.$message.error(this.isEdit ? '编辑失败' : '添加失败')
				})
			},
			resetForm() {
				this.isEdit = false
				this.editId = null
				this.userForm = {
					adminName: '',
					adminPhone: '',
					adminPwd: '',
					adminLevel: 1,
					adminStatus: 1,
					adminUpId: ''
				}
			},
			handleSizeChange(val) {
				this.pageCount = val
				this.pageNum = 1
				this.fetchUsers()
			},
			handleCurrentChange(val) {
				this.pageNum = val
				this.fetchUsers()
			}
		}
	}
</script>

<style scoped>
	.admin-page {
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	.page-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
	}

	.filter-section {
		display: flex;
		gap: 12px;
		align-items: center;
	}

	.level-select,
	.status-select {
		width: 120px;
	}

	.action-area {
		display: flex;
		gap: 12px;
	}

	.user-table-container {
		flex: 1;
		overflow-x: auto;
	}

	.user-table {
		width: 100%;
	}

	.pagination-area {
		display: flex;
		justify-content: flex-end;
		margin-top: 16px;
		padding-top: 12px;
		border-top: 1px solid #e5e7eb;
	}
</style>